import React from 'react';
import posthog from '../../utils/posthog';

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        posthog.capture('$exception', {
            $exception_message: error.message,
            $exception_stack: error.stack,
            $exception_type: error.name,
            $exception_component_stack: errorInfo.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center px-6">
                    <div className="max-w-lg text-center space-y-6">
                        <div className="space-y-2">
                            <p className="text-sm uppercase tracking-[0.3em] text-gray-500">Error</p>
                            <h1 className="text-4xl font-bold text-white">Something went wrong</h1>
                            <p className="text-gray-400">
                                An unexpected error occurred. Our team has been notified.
                            </p>
                        </div>
                        <button
                            onClick={() => window.location.reload()}
                            className="btn-primary"
                        >
                            Reload page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
